export const allocateCasesSampleExcelFile = [
  {
    current_agency_code: '1000',
    account_number: '1234567890',
    expiry: '31-12-21 23:59',
    allocation_purpose: 'CALLING'
  },
  {
    current_agency_code: '1000',
    account_number: '0987654321',
    expiry: '31-12-21',
    allocation_purpose: 'FIELD'
  }
];

export const allocateCasesSampleCsvFile =
  'current_agency_code,account_number,expiry,allocation_purpose\n' +
  '1000,987654321,31/12/21 23:59,BUFFER_CALLING\n' +
  '1000,876543219,31/12/21,CALLING\n' +
  'ABC,765432198,31/12/22,CENTRAL_UNIT_TRACING\n' +
  'DEF,654321987,31/12/23,FIELD\n' +
  'GHI,543219876,31/12/24,FIELD_CALLING\n' +
  'JKL,432198765,31/12/25,HUMAN_REMINDER\n' +
  'MNO,321987654,31/12/26,LITE_CALLING\n' +
  'PQR,219876543,31/12/27,NSA_CALLING';

export const deallocateCasesSampleExcelFile = [
  {
    current_agency_code: '1000',
    account_number: '1234567890',
    allocation_purpose: 'CALLING'
  },
  {
    current_agency_code: '1000',
    account_number: '0987654321',
    allocation_purpose: 'FIELD'
  }
];

export const deallocateCasesSampleCsvFile =
  'current_agency_code,account_number,allocation_purpose\n' +
  '1000,987654321,BUFFER_CALLING\n' +
  '1000,876543219,CALLING\n' +
  'ABC,765432198,CENTRAL_UNIT_TRACING\n' +
  'DEF,654321987,FIELD\n' +
  'GHI,543219876,FIELD_CALLING\n' +
  'JKL,432198765,HUMAN_REMINDER\n' +
  'MNO,321987654,LITE_CALLING\n' +
  'PQR,219876543,NSA_CALLING';
